/*
 * @Description:租户管理
 * @Author: jiang.weiwei
 * @LastEditors: cc
 * @Date: 2017-7-21
 * @LastEditTime: 2021-04-01 11:31:32
 */
'use strict';
angular
    .module('tenantManageMentModule', [
        'tenantManageMentRouterModule',
        'billingTimeSelectModule'
    ])
    .controller('tenantManageMentCtrl', [
        '$scope',
        '$state',
        'trsHttpService',
        'publicToolService',
        'messagePublishService',
        function($scope, $state, trsHttpService, publicToolService, messagePublishService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    isTenantAdmin: 'false',
                };
                var current = $state.current.name.split('.');
                $scope.assessExpand = false;
                var list = {
                    allTenantManage: {
                        name: '所有用户',
                        active: 'allTenantManage'
                    },
                    billingCenter: {
                        name: '计费模块中心',
                        active: 'billingCenter'
                    },
                    allocationOfficials: {
                        name: '国家官员配置',
                        active: 'allocationOfficials'
                    },
                    servicesconfig: {
                        name: '服务项配置',
                        active: 'servicesconfig'
                    },
                    producttrial: {
                        name: '产品试用申请',
                        active: 'producttrial'
                    },
                    moduleManage: {
                        name: '租户模块管理',
                        active: 'moduleManage'
                    },
                    regionManage: {
                        name: '租户地域管理',
                        active: 'regionManage'
                    },
                    territoryPoint: {
                        name: '租户领域配置',
                        active: 'territoryPoint'
                    },
                    brokeNewsAccount: {
                        name: '租户爆料账户',
                        active: 'brokeNewsAccount'
                    },
                    moduleSetting: {
                        name: '租户模块配置',
                        active: 'moduleSetting'
                    },
                    regionSetting: {
                        name: '租户模块配置',
                        active: 'regionSetting'
                    },
                    tenantDataConfig: {
                        name: '租户成品数据配置',
                        active: 'tenantDataConfig'
                    },
                    basicInfoSetting: {
                        name: '企业基本信息',
                        active: 'basicInfoSetting'
                    },
                    productBillingInfo: {
                        name: '产品计费信息',
                        active: 'productBillingInfo'
                    },
                    infoSourceSetting: {
                        name: '信息源订阅设置',
                        active: 'infoSourceSetting'
                    },
                    manuAccessSetting: {
                        name: '稿件接入设置',
                        active: 'manuAccessSetting'
                    },
                    serviceinfo: {
                        name: '服务项信息',
                        active: 'serviceinfo'
                    },
                    assessAllocation: {
                        name: '考核相关配置',
                        active: 'assessAllocation'
                    },
                    whiteListManage: {
                        name: '考核白名单维护',
                        active: 'whiteListManage'
                    },
                    groupJudgement: {
                        name: '原创分组判断',
                        active: 'groupJudgement'
                    },
                    topicManage: {
                        name: '报题/选题配置',
                        active: 'topicManage'
                    }
                };
                $scope.optionSelected = list[current[2]].active;
                $scope.titleName = list[current[2]].name;
                autoExpand();
            }

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                requestData();
                messagePublishService.subscribe('manageConfig.getConfig', () => {
                });
                publicToolService.getModeconfiguration('tenantLeftShield', 'managementConfiguration').then((config) => {
                    $scope.status.tenantManage = config;
                });
            }

            /**
             * [requestData description] 数据请求
             * @return  {[type]}  [return description]
             */
            function requestData() {
                var params = {
                    serviceid: 'mlf_extuser',
                    methodName: 'isAdministrator'
                };
                trsHttpService
                    .httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function(data) {
                        $scope.status.isTenantAdmin = data.ISADMINISTRATOR;
                    });
            }

            $scope.setSelectedOption = function(item, title) {
                $scope.optionSelected = item;
                $scope.titleName = title;
            };

            /** [description] 点击稿库接入时 刷新右边栏 */
            $scope.$on('tenantManageMent', function() {
                $scope.setSelectedOption('manuAccessSetting', '稿件接入设置');
            });

            /**
             * [autoExpand description]
             * @return  {[type]}  [return description]
             */
            function autoExpand() {
                if (
                    $scope.optionSelected === 'whiteListManage' ||
                    $scope.optionSelected === 'groupJudgement'
                ) {$scope.assessExpand = true;}
            }
        }
    ]);
